import React, { useEffect, memo } from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';

import SelectInput from 'components/SelectInput';
// import { GET_FEE_STRUCTURE } from 'services/api';

const FeeStructureSelect = ({
  testId,
  label,
  name,
  error,
  required,
  placeholder = '',
  control,
  getOptionValue,
  getOptionLabel,
  onChange,
  labelClassName,
  inputBelowLabel,
  ...rest
}) => {
  // const [options, setOptions] = useState([]);

  useEffect(() => {
    // getMerchantCategoryCodes();
  }, []);

  // const getMerchantCategoryCodes = async () => {
  //   const { data } = await GET_FEE_STRUCTURE();
  //   const _data = data.map((item) => {
  //     return {
  //       label: item.name,
  //       value: item.id,
  //     };
  //   });
  //   setOptions(_data);
  // };

  return (
    <Controller
      control={control}
      name={name}
      rules={{ required }}
      render={({ field: { ref, value, ..._field } }) => (
        <SelectInput
          {..._field}
          {...rest}
          value={value}
          testId={testId}
          name={name}
          label={label}
          labelClassName={labelClassName}
          options={[]}
          getOptionLabel={getOptionLabel}
          getOptionValue={getOptionValue}
          onChange={(option) => onChange(option, _field.onChange)}
          error={error}
          inputBelowLabel={inputBelowLabel}
        />
      )}
    />
  );
};

FeeStructureSelect.propTypes = {
  testId: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  control: PropTypes.shape({}),
  error: PropTypes.string,
  required: PropTypes.bool,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  inputBelowLabel: PropTypes.bool,
};
FeeStructureSelect.defaultProps = {
  testId: 'fee-structure-select',
  label: 'Fee Structure',
  name: 'fee-structure-select',
  control: {},
  error: null,
  required: false,
  getOptionLabel: (option) => option.label,
  getOptionValue: (option) => option.value,
  onChange: (option, _cb) => _cb(option),
  inputBelowLabel: true,
};

export default memo(FeeStructureSelect);
